import React, { ReactNode, useMemo } from 'react';
import { Element } from './TabGroup.styles';
import { TabContext } from '@/components/tab';

export interface TabGroupProps {
  tabActive: string;
  toggle: (tabId: string) => void;
  children?: ReactNode;
}

const TabGroup = ({ tabActive, toggle, children, ...props }: TabGroupProps) => {
  const context = useMemo(() => ({ tabActive, toggle }), [tabActive, toggle]);
  return (
    <TabContext.Provider value={context}>
      <Element>{children}</Element>
    </TabContext.Provider>
  );
};

export default TabGroup;
